<div class="flex flex-col gap-1 w-full animate-fade-in p-4">
  <app-header
    title="Currencies"
    searchPlaceholder="Search currencies..."
    newButtonTooltip="New Currency"
    [showFilter]="false"
    [showNew]="true"
    (onSearch)="handleSearch($event)"
    (onNewClick)="openModal()"
  ></app-header>

  <app-table
    [allData]="tableData"
    [columns]="tableColumns"
    [actions]="tableActions"
    [totalRecords]="totalRecords"
    [loading]="loading"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    (onLazyLoad)="loadLazy($event)"
  ></app-table>
</div>
